module.exports = typeof templateVars !== 'undefined' && typeof testComponentName !== 'undefined' && testComponentName === 'breadcrumbs/short' && templateVars.config ?
				templateVars.config :
				{
	"titleParam": "shortTitle",
	"typeOfshortening": "leftToRight",
	"dontRollUpFirst": true,
	"tooltipTitle": false
};


//////////////////
// WEBPACK FOOTER
// ./temp/components/breadcrumbs/.variant/short/config.yaml
// module id = 112
// module chunks = 0